import { sendHTTPRequest } from "@/util/http.ts";
const toolkitUrl = import.meta.env.VITE_TOOLKIT_URL

interface StringStringArrayPair {
  [key: string]: string[]
}
export async function getStrategyTags(params = {}): Promise<StringStringArrayPair> {
  const options = new URLSearchParams(params)
  try {
    const response = await sendHTTPRequest({
      url: `${toolkitUrl}/api/strategy_tags?${options.toString()}`,
      method: 'GET',
      includeCredentials: true
    })
    return await response.json() as StringStringArrayPair
  } catch (e) {
    throw new Error('Failed to get strategy tags', { cause: e })
  }
}